import React from 'react';
import MainHeader from 'components/headers/MainHeader';
import muiThemeable from 'material-ui/styles/muiThemeable';

const HeaderContent = ({
  label,
  muiTheme: { palette },
}) => (
  <div style={{
    backgroundColor: palette.primary1Color,
    padding: '10px 0px 10px 30px',
  }}
  >
    <MainHeader style={{ color: palette.alternateTextColor }}>{label.toUpperCase()}</MainHeader>
  </div>
);

HeaderContent.propTypes = {};
HeaderContent.defaultProps = {};

export default muiThemeable()(HeaderContent);



// WEBPACK FOOTER //
// ./src/components/headers/HeaderContent.js